<button [id]="id" [type]="btnType" [ngClass]="btnCss" #btn [title]="btnTitle" [disabled]="isDisable"
  (click)="onClick($event)" [ngbScrollSpyItem]="scrollSpyItem" [fragment]="section" [routerLink]="routerLink"
  [routerLinkActive]="routerLinkActive">
  <ng-container *ngIf="iconSrc">
    <img [src]="iconSrc" alt="Icon">
  </ng-container>
  <ng-content *ngIf="!iconSrc"></ng-content>
  {{btnText}}
</button>